/// <amd-module name="Artifacts/Cargo/commands/Badge" />
import { getBadgeCommandCreator } from "Artifacts/Root/protocols/Commands";

export const createBadgeCommand = getBadgeCommandCreator();
